import React from 'react';
import Router from 'next/router';
import { useGate } from 'statsig-react';
import { theme } from '@components-shared/src/stitches';
import { FEATURE_GATES, NAV_LINKS } from '@utils/constants';
import { scrollToTop } from '@utils/helpers';
import { resetFilters, resetParams } from '../helpers';
import { EXPLORE_TYPES, type ExploreTypeChoice } from '../schema';
import { setDefaultSort, setExploreType } from '../useSearchPageStore';
import { ChartCard } from './ChartCard';
import { ExploreCard } from './ExploreCard';

export const onExploreCardClick = ({ type }: { type: ExploreTypeChoice }) => {
  if (type === EXPLORE_TYPES.UPCOMING_DROPS) {
    Router.push(NAV_LINKS.Upcoming);
  } else {
    Router.push(NAV_LINKS.Explore).then(() => {
      setExploreType({ type });
      resetFilters();
      resetParams();
      scrollToTop();
      setDefaultSort({ type });
    });
  }
};

export const MoreSection = () => {
  const { value: pointsEnabled } = useGate(FEATURE_GATES.SOCIALS_POINTS);
  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex justify-between">
        <h3 className="font-title text-title-m font-medium md:text-title-l">More</h3>
      </div>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-4 lg:grid-cols-5 xl:grid-cols-6">
        <ChartCard
          key="viralSounds"
          label="Viral Sounds"
          pathnameUri={pointsEnabled ? NAV_LINKS.ViralSounds : NAV_LINKS.ViralChartsSounds}
          className="bg-education200"
        />
        <ChartCard
          key="viralPlaylists"
          label="Viral Playlists"
          pathnameUri={pointsEnabled ? NAV_LINKS.ViralPlaylists : NAV_LINKS.ViralChartsPlaylists}
          className="bg-brand500"
        />
        <ExploreCard
          key="upcomingDrops"
          label="Upcoming Drops"
          className="bg-green300"
          onClick={() => onExploreCardClick({ type: EXPLORE_TYPES.UPCOMING_DROPS })}
          backgroundColor=""
        />
        <ExploreCard
          key="sounds"
          label="Sounds"
          backgroundColor={theme.colors.userEducation600.toString()}
          onClick={() => onExploreCardClick({ type: EXPLORE_TYPES.SOUNDS })}
        />
        <ExploreCard
          key="artists"
          label="Artists"
          backgroundColor={theme.colors.accent700.toString()}
          onClick={() => onExploreCardClick({ type: EXPLORE_TYPES.ARTISTS })}
        />
        <ExploreCard
          key="playlists"
          label="Playlists"
          backgroundColor={theme.colors.brand600.toString()}
          onClick={() => onExploreCardClick({ type: EXPLORE_TYPES.PLAYLISTS })}
        />
        <ExploreCard
          key="collectors"
          label="Collectors"
          backgroundColor={theme.colors.base600.toString()}
          onClick={() => onExploreCardClick({ type: EXPLORE_TYPES.COLLECTORS })}
        />
      </div>
    </div>
  );
};
